import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { IFinding, IZone } from '../../models/detection.interface';
import {
    ICharts,
    ICompleteUploadRequest,
    ICreateJobRequest,
    IFindingsPage,
    IFindingsRequest,
    IIngestVmsRequest,
    IInitiateUploadRequest,
    IInitiateUploadResponse,
    IJobResults,
    ISpotlyteJob,
    ISpotlyteJobDetail,
    ISpotlyteQnaTurn,
    ISpotlyteSource,
    ISummary,
} from '../../models/spotlyte.interface';

export const SpotlyteActions = createActionGroup({
    source: 'Spotlyte',
    events: {
        // Sources
        loadSources: emptyProps(),
        loadSourcesSuccess: props<{ sources: ISpotlyteSource[] }>(),
        loadSourcesFailure: props<{ error: Error }>(),

        deleteSources: props<{ ids: string[] }>(),
        deleteSourcesSuccess: props<{ deleted: ISpotlyteSource[] }>(),
        deleteSourcesFailure: props<{ error: Error }>(),

        initiateUpload: props<{ request: IInitiateUploadRequest }>(),
        initiateUploadSuccess: props<{ response: IInitiateUploadResponse }>(),
        initiateUploadFailure: props<{ error: Error }>(),

        completeUpload: props<{ request: ICompleteUploadRequest }>(),
        completeUploadSuccess: props<{ source: ISpotlyteSource }>(),
        completeUploadFailure: props<{ error: Error }>(),

        createVmsSources: props<{ requests: IIngestVmsRequest[] }>(),
        createVmsSourcesSuccess: props<{ sources: ISpotlyteSource[] }>(),
        createVmsSourcesFailure: props<{ error: Error }>(),

        // Jobs
        loadJobs: props<{ status?: string }>(),
        loadJobsSuccess: props<{ jobs: ISpotlyteJob[] }>(),
        loadJobsFailure: props<{ error: Error }>(),

        loadJob: props<{ jobId: string }>(),
        loadJobSuccess: props<{ job: ISpotlyteJobDetail }>(),
        loadJobFailure: props<{ error: Error }>(),
        clearSelectedJob: emptyProps(),

        createJob: props<{ request: ICreateJobRequest }>(),
        createJobSuccess: props<{ job: ISpotlyteJob }>(),
        createJobFailure: props<{ error: Error }>(),

        cancelJobs: props<{ ids: string[] }>(),
        cancelJobsSuccess: props<{ cancelled: ISpotlyteJob[] }>(),
        cancelJobsFailure: props<{ error: Error }>(),

        // Results (summary + charts URLs)
        loadResults: props<{ jobId: string }>(),
        loadResultsSuccess: props<{ results: IJobResults }>(),
        loadResultsFailure: props<{ error: Error }>(),
        clearResults: emptyProps(),

        // Result blobs (summary, charts, zones)
        loadResultBlobsSuccess: props<{ summary: ISummary | null; charts: ICharts | null; zones: IZone[] }>(),
        loadResultBlobsFailure: props<{ error: Error }>(),

        // Findings
        loadFindings: props<{ filters: IFindingsRequest }>(),
        loadFindingsSuccess: props<{ page: IFindingsPage }>(),
        loadFindingsFailure: props<{ error: Error }>(),
        loadFindingsBlobSuccess: props<{ findings: IFinding[] }>(),
        loadFindingsBlobFailure: props<{ error: Error }>(),
        clearFindings: emptyProps(),

        // Export
        exportCsv: props<{ jobId: string; jobName: string; createdAt: string }>(),
        exportCsvSuccess: emptyProps(),
        exportCsvFailure: props<{ error: Error }>(),

        exportPdf: props<{ jobId: string; jobName: string; createdAt: string }>(),
        exportPdfSuccess: emptyProps(),
        exportPdfFailure: props<{ error: Error }>(),

        // QnA
        loadQnaHistory: props<{ jobId: string }>(),
        loadQnaHistorySuccess: props<{ turns: ISpotlyteQnaTurn[] }>(),
        loadQnaHistoryFailure: props<{ error: Error }>(),

        askQuestion: props<{ jobId: string; question: string }>(),
        askQuestionSuccess: props<{ turn: ISpotlyteQnaTurn }>(),
        askQuestionFailure: props<{ error: Error }>(),
        clearQnaHistory: emptyProps(),
    },
});
